export const asFileAction = {
  data: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.88021 14.5433H2.88021C2.14687 14.5433 1.54688 13.9433 1.54688 13.21V2.54329C1.54688 1.80996 2.14687 1.20996 2.88021 1.20996H8.21354L12.2135 5.20996V9.20996H10.8802V5.87663H7.54687V2.54329H2.88021V13.21H8.88021V14.5433ZM11.5469 14.3166V12.8233L13.5135 14.79L14.4535 13.85L12.4869 11.8766H13.9802V10.5433H10.2135V14.3166H11.5469Z" fill="currentColor"/>
</svg>
`,
  name: 'file-action',
};
